import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Link } from "react-router-dom";
import moment from "moment";

const NeedsFollowUp = ({ leadsStats }) => {
  const needsFollowUp = leadsStats?.needsFollowUp || [];

  const getDaysColor = (days) => {
    if (days >= 60) return "danger";
    if (days >= 45) return "warning";
    return "info";
  };

  return (
    <React.Fragment>
      <Col lg={12}>
        <Card>
          <CardBody>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h4 className="card-title mb-0">Leads que Necesitan Seguimiento</h4>
              <span className="badge bg-warning-subtle text-warning">
                {needsFollowUp.length} leads
              </span>
            </div>

            <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table table-nowrap align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th scope="col" style={{ fontSize: "12px" }}>Lead</th>
                    <th scope="col" style={{ fontSize: "12px" }}>Última Actividad</th>
                    <th scope="col" style={{ fontSize: "12px" }}>Días Sin Actividad</th>
                    <th scope="col" style={{ fontSize: "12px", width: "80px" }}>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {needsFollowUp.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="text-center text-muted py-4">
                        <i className="ri-checkbox-circle-line text-success font-size-24 mb-2 d-block"></i>
                        Todos los leads están al día
                      </td>
                    </tr>
                  ) : (
                    needsFollowUp.map((lead, key) => (
                      <tr key={key}>
                        <td>
                          <div>
                            <p className="mb-1 fw-medium" style={{ fontSize: "13px" }}>
                              {lead.name} {lead.lastName}
                            </p>
                            <p className="text-muted mb-0" style={{ fontSize: "11px" }}>
                              {lead.email}
                            </p>
                          </div>
                        </td>
                        <td>
                          <span className="text-muted" style={{ fontSize: "12px" }}>
                            {lead.lastActivity
                              ? moment(lead.lastActivity).format("DD/MM/YY")
                              : "Nunca"}
                          </span>
                        </td>
                        <td>
                          <span className={`badge bg-${getDaysColor(lead.daysSinceActivity)}-subtle text-${getDaysColor(lead.daysSinceActivity)}`} style={{ fontSize: "11px" }}>
                            {lead.daysSinceActivity} días
                          </span>
                        </td>
                        <td>
                          <Link to={`/leads/${lead.id}`}>
                            <button
                              type="button"
                              className="btn btn-soft-warning btn-sm"
                              title="Contactar lead"
                              style={{ padding: "4px 8px" }}
                            >
                              <i className="ri-phone-line"></i>
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default NeedsFollowUp;

